export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14465.f48fbc24.jpg";